import {
  MDSIconKind,
  MDSMenuItemSelectionVariant,
  MDSMenuItemVariant,
  MDSActionMenu,
  MDSActionMenuItem,
  MDSMenuItemHeader,
  MDSMenuDropdown,
  MDSMenuDropdownSlotName,
  MDSToggleButton,
} from "@/mds";
import { ReactNode, useState } from "react";
import { SortByKind } from "@/modules/lenses/types";
import { lensModule } from "@/modules/lenses";

interface SortByDropdownButtonProps {
  sortOptions: SortByKind[];
  defaultSortOption: SortByKind;
  selectedSortOption: SortByKind;
  onSelectSortOption: (sortOption: SortByKind) => void;
  customTrigger?: (isOpen: boolean) => ReactNode;
  alwaysToggled?: boolean;
}

export const SortByDropdownButton = ({
  sortOptions,
  defaultSortOption,
  selectedSortOption,
  onSelectSortOption,
  customTrigger,
  alwaysToggled,
}: SortByDropdownButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <MDSMenuDropdown data-test-id="sort-by-dropdown-button" onOpenChange={setIsOpen}>
      {customTrigger ? (
        customTrigger(isOpen)
      ) : (
        <MDSToggleButton
          slot={MDSMenuDropdownSlotName.Trigger}
          iconKind={MDSIconKind.SortAlt}
          isOpen={isOpen}
          isToggled={alwaysToggled || selectedSortOption !== defaultSortOption}
          label={lensModule.sortKindLabelMap[selectedSortOption]}
        />
      )}
      <MDSActionMenu
        aria-label="Sort by"
        style={{ minWidth: 176, maxWidth: 320 }}
        slot={MDSMenuDropdownSlotName.Menu}
      >
        <MDSMenuItemHeader label="Sort by" />
        {sortOptions.map(sortOption => {
          return (
            <MDSActionMenuItem
              key={sortOption}
              id={sortOption}
              variant={MDSMenuItemVariant.OneLine}
              label={lensModule.sortKindLabelMap[sortOption]}
              isSelected={selectedSortOption === sortOption}
              selectionVariant={MDSMenuItemSelectionVariant.Checkmark}
              onClick={() => {
                onSelectSortOption(sortOption);
              }}
            />
          );
        })}
      </MDSActionMenu>
    </MDSMenuDropdown>
  );
};
